module.exports = __webpack_public_path__ + "img/2.efb97366.png";